import { render, staticRenderFns } from "./PacotesInternacionais.vue?vue&type=template&id=0d65e6cf&scoped=true&"
import script from "./PacotesInternacionais.vue?vue&type=script&lang=js&"
export * from "./PacotesInternacionais.vue?vue&type=script&lang=js&"
import style0 from "./PacotesInternacionais.vue?vue&type=style&index=0&id=0d65e6cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d65e6cf",
  null
  
)

export default component.exports